import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfDigitalIntensityScoreAveragesSummaryApplicationService } from '../../../core/application/services/scores/get-self-digital-intensity-score-averages-summary.application-service';
import { SelfDigitalIntensityScoreAveragesSummaryEntity } from '../../../core/domain/entities/scores/self-digital-intensity-score-averages-summary.entity';
import { GetSelfScoreAveragesSummaryRequestDto } from '../../dtos/scores/self-get-score-averages-summary.request.dto';

export class GetSelfDigitalIntensityScoreAveragesSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfDigitalIntensityScoreAveragesSummaryApplicationService
  ) {}
  async execute(
    props: GetSelfScoreAveragesSummaryRequestDto
  ): Promise<SelfDigitalIntensityScoreAveragesSummaryEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
